import React from 'react';
import { graphql } from "react-apollo";
import { NavLink } from "react-router-dom";


class MailList extends React.Component {

	render() {

		const mail = this.props.mail;

		return (
			<div className="list__item">
                <NavLink to={`/mails/${mail.id}`} activeClassName="active">
					<div className="truncate">
						{mail.subject}<br />
						<span className="list__meta">{mail.from}</span>
					</div>
					{mail.unread && <div className="unread unread--dot"></div>}
				</NavLink>
		    </div>
      	)
	}
}


export default MailList


// WEBPACK FOOTER //
// ./src/components/mail/MailItem.js